export default __webpack_public_path__ + "static/media/goueli.9cc53385.jpg";